/* Tienda Novale – core behaviours shared by every page. */
(function () {
  const TN = (window.TN = window.TN || {});
  const settings = () => window.themeSettings || {};

  TN.onReady = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  };

  /* ---------- Money ---------- */
  TN.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || settings().moneyFormat || '${{amount}}';
    const withDelimiters = (number, precision, thousands = ',', decimal = '.') => {
      const fixed = (number / 100).toFixed(precision);
      const [whole, fraction] = fixed.split('.');
      const grouped = whole.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
      return fraction ? grouped + decimal + fraction : grouped;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return withDelimiters(cents, 2);
        case 'amount_no_decimals': return withDelimiters(cents, 0);
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return withDelimiters(cents, 0, ' ', '');
        case 'amount_with_space_separator': return withDelimiters(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return withDelimiters(cents, 2, ' ', '.');
        default: return withDelimiters(cents, 2);
      }
    });
  };

  /* ---------- Lazy script loader ---------- */
  const loaded = {};
  TN.loadScript = function (src) {
    if (!loaded[src]) {
      loaded[src] = new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = src;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    return loaded[src];
  };

  /* ---------- Section load animations ---------- */
  function initAnimations(root = document, instant = false) {
    if (!settings().loadAnimations) return;
    const items = root.querySelectorAll('.animate-section');
    if (!items.length) return;
    TN.animationsReady = true;
    if (instant) {
      items.forEach((el) => {
        el.classList.remove('animate--hidden');
        el.classList.add('animate--shown');
      });
      return;
    }
    const sticky = document.querySelector('.sticky-atc');
    const bottom = 50 + (sticky ? sticky.clientHeight : 0);
    const repeat = settings().repeatAnimations;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.remove('animate--hidden');
            entry.target.classList.add('animate--shown');
            if (!repeat) observer.unobserve(entry.target);
          } else if (repeat && entry.target.classList.contains('animate--shown')) {
            entry.target.classList.remove('animate--shown');
            entry.target.classList.add('animate--hidden');
          }
        });
      },
      { rootMargin: `0px 0px -${bottom}px 0px` }
    );
    items.forEach((el) => observer.observe(el));
  }
  TN.initAnimations = initAnimations;

  /* ---------- Protect content (optional) ---------- */
  function protectContent() {
    if (!settings().disableInspect) return;
    const stop = (e) => e.preventDefault();
    window.addEventListener('contextmenu', stop);
    document.addEventListener('selectstart', (e) => {
      if (!e.target.closest || !e.target.closest('input, textarea, [contenteditable]')) e.preventDefault();
    });
    document.addEventListener('dragstart', (e) => {
      if (e.target.tagName === 'IMG') e.preventDefault();
    });
    document.addEventListener('keydown', (e) => {
      const key = (e.key || '').toUpperCase();
      const devtools = e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].includes(key);
      if (key === 'F12' || devtools || (e.ctrlKey && key === 'U')) e.preventDefault();
    });
  }

  /* ---------- Country blocker ---------- */
  async function countryBlocker() {
    const s = settings();
    if (Shopify.designMode) return;
    const list = (s.countryList || '')
      .split(',')
      .map((c) => c.trim().toUpperCase())
      .filter(Boolean);
    if (!list.length) return;
    let country = sessionStorage.getItem('tn-country');
    if (!country) {
      try {
        const res = await fetch(`${window.routes.root_url.replace(/\/$/, '')}/browsing_context_suggestions.json`);
        const data = await res.json();
        country = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (country) sessionStorage.setItem('tn-country', country);
      } catch (e) {
        return;
      }
    }
    if (!country) return;
    const listed = list.includes(country.toUpperCase());
    const blocked = s.countryListFunction === 'whitelist' ? !listed : listed;
    if (!blocked) return;
    document.body.innerHTML = `<div class="country-blocked page-width rte">${s.countryBlockedMessage || ''}</div>`;
    document.body.classList.add('country-blocked-body');
  }

  /* ---------- External links in a new tab ---------- */
  function externalLinks() {
    const host = window.location.hostname;
    document.querySelectorAll('a[href^="http"]').forEach((a) => {
      if (a.hostname && a.hostname !== host) {
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
      }
    });
  }

  /* ---------- Buttons that submit the main product form from other sections ---------- */
  function sectionAtcButtons() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-main-atc]');
      if (!button) return;
      const form = document.querySelector('product-form[data-main="true"]');
      if (!form || typeof form.onSubmitHandler !== 'function') return;
      event.preventDefault();
      form.onSubmitHandler(event);
    });
  }

  /* ---------- Scroll to a section id from any "#id" link ---------- */
  function smoothAnchors() {
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const id = link.getAttribute('href').slice(1);
      if (!id) return;
      const target = document.getElementById(id);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---------- Slider (Splide) ---------- */
  class TnSlider extends HTMLElement {
    connectedCallback() {
      this.root = this.querySelector('.splide');
      if (!this.root || this.splide) return;
      const src = this.dataset.src || (window.TN_ASSETS && window.TN_ASSETS.splide);
      const ready = window.Splide ? Promise.resolve() : TN.loadScript(src);
      ready.then(() => this.mount()).catch(() => {});
    }

    disconnectedCallback() {
      if (this.splide) this.splide.destroy();
      this.splide = null;
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }

    num(value, fallback) {
      const n = parseFloat(value);
      return isNaN(n) ? fallback : n;
    }

    options() {
      const d = this.dataset;
      const typeMap = { classic: 'slide', slide: 'slide', infinite: 'loop', loop: 'loop', fade: 'fade' };
      const type = typeMap[d.type] || 'slide';
      const drag = d.drag === 'false' ? false : d.drag === 'free' ? 'free' : true;
      const arrowClass = d.arrowsColor ? ` color-${d.arrowsColor}` : '';
      const dotClass = d.dotsColor ? ` color-${d.dotsColor} dots-custom-color` : '';
      const perPage = this.num(d.perPage, 1);
      const padRight = this.num(d.paddingRight, 0);
      const padRightMobile = this.num(d.paddingRightMobile, 0);
      return {
        type,
        rewind: type === 'fade',
        autoplay: d.autoplay === 'true',
        interval: this.num(d.interval, 5) * 1000,
        pauseOnHover: d.pauseOnHover !== 'false',
        speed: this.num(d.speed, 400),
        drag,
        focus: d.focus === 'center' ? 'center' : 0,
        trimSpace: d.trimSpace !== 'false',
        omitEnd: d.omitEnd !== 'false',
        arrows: d.arrows !== 'false',
        pagination: d.pagination !== 'false',
        autoWidth: d.autoWidth === 'true',
        perPage,
        perMove: this.num(d.perMove, 1),
        gap: this.num(d.gap, 30),
        padding: { left: d.paddingCalc === 'true' ? 0 : this.num(d.paddingLeft, padRight), right: padRight },
        destroy: d.destroy === 'true',
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        classes: {
          arrow: `splide__arrow${arrowClass}`,
          page: `splide__pagination__page${dotClass}`,
        },
        i18n: {
          prev: this.dataset.labelPrev || 'Previous slide',
          next: this.dataset.labelNext || 'Next slide',
        },
        breakpoints: {
          749: {
            type: typeMap[d.typeMobile] || type,
            perPage: this.num(d.perPageMobile, 1),
            perMove: this.num(d.perMoveMobile, 1),
            gap: this.num(d.gapMobile, 15),
            padding: {
              left: d.paddingCalcMobile === 'true' ? 0 : this.num(d.paddingLeftMobile, padRightMobile),
              right: padRightMobile,
            },
            destroy: d.destroyMobile === 'true',
            omitEnd: d.omitEnd !== 'false',
          },
        },
      };
    }

    mount() {
      if (!window.Splide || this.splide) return;
      const splide = new window.Splide(this.root, this.options());
      this.splide = splide;

      const syncHeight = () => {
        const slide = splide.Components.Elements && splide.Components.Elements.slides[splide.index];
        if (!slide) return;
        this.root.classList.toggle('has-active-height', true);
        this.style.setProperty('--active-slide-height', `${slide.offsetHeight}px`);
      };
      const markActive = () => {
        const slides = (splide.Components.Elements && splide.Components.Elements.slides) || [];
        slides.forEach((s, i) => s.classList.toggle('is-instant-active', i === splide.index));
        syncHeight();
      };

      splide.on('mounted', () => {
        const slide = splide.Components.Elements.slides[splide.index];
        const img = slide && slide.querySelector('img');
        if (img && !img.complete) img.addEventListener('load', markActive, { once: true });
        else markActive();
      });
      splide.on('move', markActive);

      if (this.dataset.pauseVideos === 'true') {
        splide.on('hidden', (component) => {
          const video = component.slide.querySelector('internal-video');
          if (video && typeof video.onSlideHidden === 'function') video.onSlideHidden();
        });
      }

      splide.mount();
      this.onResize = debounceSimple(syncHeight, 200);
      window.addEventListener('resize', this.onResize);
      this.dispatchEvent(new CustomEvent('tn-slider:mounted', { bubbles: true, detail: { splide } }));
    }
  }

  function debounceSimple(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  TN.debounce = debounceSimple;

  if (!customElements.get('tn-slider')) customElements.define('tn-slider', TnSlider);

  /* ---------- Colour swatches on product cards ---------- */
  class CardSwatches extends HTMLElement {
    connectedCallback() {
      try {
        this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      } catch (e) {
        this.variants = [];
      }
      this.position = parseInt(this.dataset.optionPosition, 10) - 1;
      this.addEventListener('change', (event) => {
        if (event.target.matches('input[type="radio"]')) this.select(event.target.value);
      });
    }

    select(value) {
      const matches = this.variants.filter((v) => v.options[this.position] === value);
      const variant = matches.find((v) => v.available) || matches[0];
      if (!variant) return;
      const formId = this.dataset.formId;

      const image = document.getElementById(`${formId}-image`);
      if (image && variant.image) {
        const base = variant.image.split('?')[0];
        const widths = [165, 360, 533, 720, 940, 1066].filter((w) => !variant.width || variant.width >= w);
        image.srcset = widths.map((w) => `${base}?width=${w} ${w}w`).join(', ');
        image.src = `${base}?width=533`;
      }

      const form = document.getElementById(formId);
      const idInput = form && form.querySelector('input[name="id"]');
      if (idInput) idInput.value = variant.id;

      const submit = document.getElementById(`${formId}-submit`);
      if (submit) {
        if (submit.dataset.productUrl !== undefined) {
          submit.dataset.productUrl = `${this.dataset.url}?variant=${variant.id}`;
        } else {
          submit.toggleAttribute('disabled', !variant.available);
          const label = submit.querySelector('span');
          if (label && window.variantStrings) {
            label.textContent = variant.available ? window.variantStrings.addToCart : window.variantStrings.soldOut;
          }
        }
      }
    }
  }
  if (!customElements.get('card-swatches')) customElements.define('card-swatches', CardSwatches);

  /* ---------- Copy a discount code ---------- */
  class TnCopyCode extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button') || this;
      button.addEventListener('click', () => {
        const code = (this.dataset.code || '').trim();
        const done = () => {
          this.classList.add('is-copied');
          setTimeout(() => this.classList.remove('is-copied'), 2000);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done);
        else done();
      });
    }
  }
  if (!customElements.get('tn-copy-code')) customElements.define('tn-copy-code', TnCopyCode);

  /* ---------- Floating buttons ---------- */
  class TnScrollTop extends HTMLElement {
    connectedCallback() {
      this.after = parseInt(this.dataset.after, 10) || 0;
      this.querySelector('button').addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
      if (this.after > 0) {
        this.onScroll = () => this.classList.toggle('is-hidden', window.scrollY <= this.after);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }
    }

    disconnectedCallback() {
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    }
  }
  if (!customElements.get('tn-scroll-top')) customElements.define('tn-scroll-top', TnScrollTop);

  class TnAudioPlayer extends HTMLElement {
    connectedCallback() {
      this.audio = this.querySelector('audio');
      this.button = this.querySelector('button');
      this.audio.volume = Math.min(1, Math.max(0, parseFloat(this.dataset.volume) || 0.1));
      this.button.addEventListener('click', () => this.toggle());
    }

    toggle() {
      if (this.audio.paused) {
        document.querySelectorAll('tn-audio-player').forEach((player) => player !== this && player.stop && player.stop());
        this.audio.play().catch(() => {});
        this.classList.add('is-playing');
        this.button.setAttribute('aria-pressed', 'true');
      } else {
        this.stop();
      }
    }

    stop() {
      this.audio.pause();
      this.classList.remove('is-playing');
      this.button.setAttribute('aria-pressed', 'false');
    }
  }
  if (!customElements.get('tn-audio-player')) customElements.define('tn-audio-player', TnAudioPlayer);

  /* ---------- Boot ---------- */
  TN.onReady(() => {
    initAnimations(document, false);
    protectContent();
    countryBlocker();
    externalLinks();
    sectionAtcButtons();
    smoothAnchors();
  });

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      initAnimations(e.target, true);
      externalLinks();
    });
    document.addEventListener('shopify:section:reorder', () => initAnimations(document, true));
  }
})();
